<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.1667 1.5C12.1708 7.38931 16.944 12.1625 22.8333 12.1667C16.944 12.1708 12.1708 16.944 12.1667 22.8333C12.1625 16.944 7.38931 12.1708 1.5 12.1667C7.38931 12.1625 12.1625 7.38931 12.1667 1.5Z"
      fill="#6941C6"
    />
  </svg>
</template>
